<template>
  <div class="home">
    <MainHeader/>
    <MainLogo/>
    <UserAccount/>
    <MainFooter/>
  </div>
</template>

<script>
// @ is an alias to /src
import PreLoader from '@/components/PreLoader.vue'
import MainHeader from '@/components/MainHeader.vue'
import MainLogo from '@/components/MainLogo.vue'
import UserAccount from '@/components/UserAccount.vue'
import PopUP from '@/components/Popup.vue'
import MainFooter from '@/components/MainFooter.vue'
import { mapGetters } from 'vuex';

export default {
  name: 'Account',
  components: {
    PreLoader,
    MainHeader,
    MainLogo,
    UserAccount,
    PopUP,
    MainFooter
  },
  created() {
    this.storeSession()
    this.$store.dispatch('checkLoggedInUser')
  },
  methods: {
    storeSession(){
      if(this.$session.exists() == false)
      {
        let user_key = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 34);
        // console.log(user_key)
        this.$session.set('user_key', user_key)
        sessionStorage.setItem('user_key', user_key)
      }
      
    }
  },
}
</script>
